import React, { useEffect, useMemo, useState } from "react";
import ContactDashBoardHeader from "../../../v2/layout/ContactDashBoardHeader";
import ContactLeftPanel from "../../../v2/layout/ContactLeftPanel";
import { Outlet, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import "../../../v2/features/dashboard/contractDashboard.css";
import {
  getContactInformation,
  TRIGGER_USER_PROFILE_REQUEST,
} from "app/redux/features/contactById";
import { getObjectFromLocalStore } from "app/utils/localStore";
import { formatPhoneNumber } from "app/utils/utils";
import { setObjectInSessionStore } from "app/utils/sessionStore";
import { ContactProfileDetailsContext } from "./ContactLayout";

/**
 * Development layout for v2-dashboard route
 * Uses the same sidebar and header as ContactLayout
 */
function ContactV2Layout() {
  const {
    agentContactSuccess,
    agentContactProfilePictureUploadSuccess,
    agentContactBasicInfoEditSuccess,
  } = useSelector(getContactInformation);

  const [isOpen, setIsOpen] = useState(false);

  const userAccess = getObjectFromLocalStore("useraccess");
  const dispatch = useDispatch();
  const { pathname } = useLocation();

  const contactId = agentContactSuccess?.data?.id ?? "";
  const contactProfilePic = agentContactSuccess?.data?.profilePicture ?? "";
  const isVerified = (agentContactSuccess?.data as any)?.isVerified ?? "";
  const contactFirstName = agentContactSuccess?.data?.firstName ?? "";
  const contactLastName = agentContactSuccess?.data?.lastName ?? "";
  const agentProfilePic = agentContactSuccess?.data?.agent?.profilePicture ?? "";
  const agentName = agentContactSuccess?.data?.agent?.name ?? "";
  const agentID = agentContactSuccess?.data?.agent?.id ?? "";
  const agentEmail = agentContactSuccess?.data?.agent?.email ?? "";
  const agentPhone = formatPhoneNumber(agentContactSuccess?.data?.agent?.contact?.phoneNumber);
  setObjectInSessionStore("contactId", { id: contactId });

  const contextValue = useMemo(
    () => ({
      contactId,
      contactProfilePic,
      isVerified,
      contactFirstName,
      contactLastName,
      agentProfilePic,
      agentName,
      agentID,
      agentEmail,
      agentPhone,
      isOpen,
      setIsOpen,
    }),
    [
      contactId,
      agentContactSuccess,
      isVerified,
      contactFirstName,
      contactLastName,
      agentProfilePic,
      agentName,
      agentID,
      agentEmail,
      agentPhone,
      isOpen,
      setIsOpen,
    ],
  );

  useEffect(() => {
    if (userAccess?.userType === "contact") {
      dispatch({
        type: TRIGGER_USER_PROFILE_REQUEST,
        payload: {
          address: "contact",
        },
      });
    }
  }, [agentContactProfilePictureUploadSuccess?.data, agentContactBasicInfoEditSuccess?.data]);

  const isAgentContactRouteForContactUser =
    pathname.includes("agent/contact") && userAccess?.userType === "contact";
  const isNotificationPage = pathname.includes("notification");

  return (
    <ContactProfileDetailsContext.Provider value={contextValue}>
      <div className="relative h-screen">
        <ContactDashBoardHeader />
        <div className="h-full flex bg-[var(--surface-ground)]">
          <ContactLeftPanel />
          <div
            id={pathname.includes("academy") ? "course-list" : undefined}
            className={`flex-1 overflow-auto scrollbar-hide app-scroll-container ${
              isAgentContactRouteForContactUser
                ? "h-full mt-[85px]"
                : isNotificationPage
                ? "h-[calc(100vh-110px)] mt-auto"
                : "h-[calc(100vh-140px)] mt-auto"
            }`}
          >
            <Outlet />
          </div>
        </div>
      </div>
    </ContactProfileDetailsContext.Provider>
  );
}

export default ContactV2Layout;
